import type { BoardSummary } from "@mn/shared";
import { Link } from "react-router";

export function BoardTile({ board }: { board: BoardSummary }) {
  const color = board.iconColor ?? "#2a2a2a";
  const letter = (board.title.trim()[0] ?? "?").toUpperCase();
  return (
    <Link to={`/b/${board.id}`} className="group flex w-28 flex-col items-center gap-2 no-underline">
      <div
        className="display flex size-24 items-center justify-center rounded-[22px] border border-border text-5xl text-text shadow-panel transition group-hover:scale-105"
        style={{ background: color }}
      >
        {board.icon ?? letter}
      </div>
      <span className="line-clamp-2 w-full text-center text-sm leading-tight text-text">{board.title}</span>
    </Link>
  );
}
